<template>
  <div class="wrapper">
    <!-- BEGIN CONTAINER -->
    <div class="page-container">
      <div class="page-content-wrapper">
        <!-- BEGIN CONTENT BODY -->
        <div class="page-content" :style="`min-height: ${minHeight}px`">
          <div class="main-page">
            <br/>
            <div class="home-title">
              <h1 class="text-center"> Huyền Học Phương Đông </h1>
              <p class="text-center"><i>Đạo là triết học của giới tự nhiên</i></p>
            </div>

            <br/><br/>
            <div class="row">
              <div class="container">
                <div class="col-md-3 text-center">
                  <router-link :to="{name: 'TuTru'}">
                    <div class="link-item">
                      <div class="img">
                        <img src="@/assets/img/battu-icon.png" width="100%">
                      </div>
                      <p class="text-center">Tứ Trụ</p>
                    </div>
                  </router-link>
                </div>

                <div class="col-md-3 text-center">
                  <router-link :to="{name: 'TuVi'}">
                    <div class="link-item">
                      <div class="img">
                        <img src="@/assets/img/tu-vi2.png"
                             width="80%">
                      </div>
                      <p class="text-center">Tử vi</p>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-3 text-center">
                  <router-link :to="{name: 'LucHao'}">
                    <div class="link-item">
                      <div class="img">
                        <img src="@/assets/img/gieo-que1.png" width="100%">
                      </div>
                      <p class="text-center">Lục hào</p>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-3 text-center">
                  <router-link :to="{name: 'TrachNhat'}">
                    <div class="link-item">
                      <div class="img">
                        <img src="@/assets/img/lich-tot-xau-icon.png" width="100%">
                      </div>
                      <p class="text-center">Lịch tốt xấu</p>
                    </div>
                  </router-link>
                </div>
              </div>

              <br/>
              <div class="container">
                <p class="text-center"><i>Tận Nhân Lực - Tri Thiên Mệnh</i></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-footer">
      <div> 2020 © Thăng Long Dịch Số
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  computed: {
    minHeight () {
      return document.body.scrollHeight - 32
    }
  }
}
</script>

<style scoped src="../assets/css/tutru.css"></style>
<style scoped src="../assets/css/bootstrap.min.css"></style>
<style scoped>
  .home-title h1 {
    color: #fff;
  }

  .home-title p {
    color: #fff;
  }

  .link-item {
    display: inline-block;
    width: 100px;
    height: 100px;
    border: 1px #fff solid;
    position: relative;
  }

  .link-item:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: 0.4;
  }

  .link-item .img {
    width: 100px;
    height: 100px;
  }

  .link-item img {
    z-index: 9999;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
  }

  .page-content,
  .page-container-bg-solid .page-content {
    background: none;
  }

  .main-page p {
    color: #fff;
  }

  .page-footer {
    padding: 8px 20px 5px;
    font-size: 13px;
    height: 33px;
    /*z-index: 1000;*/
    /*position: absolute;*/
    bottom: 0px;
    color: white;
    text-align: center;
  }
</style>
